import { render, staticRenderFns } from "./customerOvertimeSettings.vue?vue&type=template&id=382e13ad&scoped=true&"
import script from "./customerOvertimeSettings.vue?vue&type=script&lang=js&"
export * from "./customerOvertimeSettings.vue?vue&type=script&lang=js&"
import style0 from "./customerOvertimeSettings.vue?vue&type=style&index=0&id=382e13ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e13ad",
  null
  
)

export default component.exports